/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';
import { resumoHoras } from './constants';

const Item = ({ label, value }) => (
  <Box sx={{ minWidth: 88 }}>
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>{label}</Typography>
    <Typography variant="body2" sx={{ fontWeight: 700 }}>{value || '—'}</Typography>
  </Box>
);

Item.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};

const diasLabel = (resumo) => {
  const parts = [];
  if (resumo.diasUteis != null) {
    parts.push(`${resumo.diasUteis} ${resumo.diasUteis === 1 ? 'dia útil' : 'dias úteis'}`);
  }
  if (resumo.sabados != null) {
    parts.push(`${resumo.sabados} ${resumo.sabados === 1 ? 'sábado' : 'sábados'}`);
  }
  return parts.join(' · ');
};

const ResumoHoras = ({ row, compact = false }) => {
  const resumo = resumoHoras(row);
  const dias = diasLabel(resumo);
  const temHoras = Boolean(resumo.esperado || resumo.registrado);
  if (!temHoras && !dias) return null;

  if (compact) {
    return (
      <Box>
        {temHoras && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            {`${resumo.registrado || '—'} registradas · ${resumo.esperado || '—'} esperadas`}
            {resumo.diferenca ? ` · ${resumo.diferenca}` : ''}
          </Typography>
        )}
        {dias && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            {dias}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Stack spacing={1}>
      <Stack
        direction="row"
        spacing={2}
        useFlexGap
        sx={{ flexWrap: 'wrap', py: 1, px: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}
      >
        <Item label="Esperadas" value={resumo.esperado} />
        <Item label="Registradas" value={resumo.registrado} />
        <Item label="Diferença" value={resumo.diferenca} />
        {resumo.diasUteis != null && <Item label="Dias úteis" value={String(resumo.diasUteis)} />}
        {resumo.sabados != null && <Item label="Sábados" value={String(resumo.sabados)} />}
      </Stack>
    </Stack>
  );
};

ResumoHoras.propTypes = {
  row: PropTypes.object,
  compact: PropTypes.bool,
};

export default ResumoHoras;
